export class CurrencyHelper {
  public static format(value: string, lang: string, currency: string): string {
    return parseFloat(value).toLocaleString(lang, {
      style: 'currency',
      currency,
    });
  }
}
